import { ReloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import { useSidebarWidth } from '@/hooks/domain/useSidebar';
import useFeedbackListStore from '@/stores/Feedback/FeedbackListStore';
import zIndex from '@/styles/zIndex';

type Props = {
  refetch: () => void;
};

const NewFeedbackNotificationModal = (props: Props) => {
  const { updatedFeedbackList, mergeUpdatedFeedback } = useFeedbackListStore(
    ({ updatedFeedbackList, mergeUpdatedFeedback }) => ({
      updatedFeedbackList,
      mergeUpdatedFeedback,
    }),
  );

  const currSidebarWidth = useSidebarWidth();

  if (updatedFeedbackList.length === 0) return null;

  return (
    <Style currSidebarWidth={currSidebarWidth} j="space-between" a="center">
      <Typo type="label2">{updatedFeedbackList.length} Feedback Updated</Typo>
      <Button
        sizeType="m"
        variant="ghost"
        leftIcon={<ReloadOutlined />}
        className="text-white hover:bg-transparent border border-white"
        style={{
          padding: '0 14px',
        }}
        onClick={() => {
          mergeUpdatedFeedback();
          props.refetch();
        }}
      >
        Refresh
      </Button>
    </Style>
  );
};

const Style = styled(Flex)<{ currSidebarWidth: number }>`
  position: fixed;
  bottom: 0;
  left: calc(
    ${(props) => props.currSidebarWidth}px +
      ((100vw - ${(props) => props.currSidebarWidth}px) / 2) - 170px
  );
  width: 340px;
  background-color: ${(props) => props.theme.colors.primary100};
  color: ${(props) => props.theme.colors.FL100};
  border-radius: 8px 8px 0 0;
  padding: 6px 16px;
  z-index: ${zIndex.toast};
`;

export default NewFeedbackNotificationModal;
